import React from 'react'
import styled from 'styled-components'
import ButtonShell from 'components/elements/ButtonShell'

const StyledButton = styled.span`
  display: inline-block;
  min-width: 240px;
  text-align: center;

  @media (max-width: 991px) {
    width: 100%;
  }

  & > a,
  & > button {
    font-family: ${(props) => props.theme.font.family.secondary};
    background-color: ${(props) => props.theme.color.face.contrast};
    border: 1px solid ${(props) => props.theme.color.face.contrast};
    color: ${(props) => props.theme.color.text.light};
    font-size: 16px;
    font-weight: 400;
    text-transform: uppercase;
    padding: 12px 15px;
    width: 100%;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 5px;

    &:hover {
      color: ${(props) => props.theme.color.text.contrast};
      background: ${(props) => props.theme.color.face.light};
      border-color: ${(props) => props.theme.color.face.light};
    }
  }
`

interface ButtonDefaultProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  children: any
  className?: string
  target?: string
  rel?: string
}

function ButtonDefault({
  isAnchor = false,
  isCustom = false,
  to,
  children,
  className = '',
  target,
  rel,
}: ButtonDefaultProps) {
  return (
    <StyledButton className={className}>
      {isCustom ? (
        children
      ) : (
        <ButtonShell to={to} isAnchor={isAnchor} target={target} rel={rel}>
          {children}
        </ButtonShell>
      )}
    </StyledButton>
  )
}

export default ButtonDefault
